// Use the existing operator-owned project, with Shopify's native consent state.
(function () {
  if (window.fenvieClarityBound) return;
  window.fenvieClarityBound = true;
  var loaded = false;
  function privacyReady() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return privacy && typeof privacy.analyticsProcessingAllowed === 'function' && typeof privacy.marketingAllowed === 'function';
  }
  function syncConsent() {
    if (!privacyReady()) return;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var analytics = privacy.analyticsProcessingAllowed();
    if (!loaded && analytics) {
      loaded = true;
      window.clarity = window.clarity || function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
      window.clarity('set', 'product', 'Fenvie Go');
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/xuqgawwu9c';
      document.head.appendChild(script);
    }
    if (loaded) window.clarity('consentv2', {
      ad_Storage: privacy.marketingAllowed() ? 'granted' : 'denied',
      analytics_Storage: analytics ? 'granted' : 'denied'
    });
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (privacyReady()) syncConsent();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) syncConsent();
    });
  }
})();
